import { useState } from 'react';
import { Box, Button, Container, IconButton, InputAdornment, TextField } from '@mui/material';
import { LoginPayload, useSession } from 'App';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { AuthErrorBox } from '@shared';

const validationSchema = yup.object({
  email: yup.string().email('Enter a valid email').required('Please, fill in this field'),
  password: yup.string().required('Please, fill in this field'),
});

export function LogIn() {
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [serverErrorMessage, setServerErrorMessage] = useState('');
  const { login } = useSession();
  const { values, touched, errors, handleChange, handleSubmit } = useFormik<LoginPayload>({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      const response = await login(values);
      response && setServerErrorMessage(response);
    },
  });

  return (
    <Container component='article' maxWidth='xs'>
      <AuthErrorBox message={serverErrorMessage} />
      <h2>Please sign in</h2>
      <Box component='form' onSubmit={handleSubmit} noValidate>
        <TextField
          InputLabelProps={{
            shrink: true,
          }}
          value={values.email}
          onChange={handleChange}
          error={touched.email && Boolean(errors.email)}
          helperText={touched.email && errors.email}
          required
          fullWidth
          label='Email Address'
          name='email'
          autoComplete='email'
          autoFocus
        />
        <TextField
          InputLabelProps={{
            shrink: true,
          }}
          sx={{ mt: 2, mb: 2 }}
          value={values.password}
          onChange={handleChange}
          error={touched.password && Boolean(errors.password)}
          helperText={touched.password && errors.password}
          required
          fullWidth
          name='password'
          label='Password'
          type={isShowPassword ? 'text' : 'password'}
          autoComplete='current-password'
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton onClick={() => setIsShowPassword((prev) => !prev)}>
                  {isShowPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button type='submit' fullWidth variant='contained' sx={{ fontSize: 16 }}>
          Sign In
        </Button>
      </Box>
    </Container>
  );
}
